// Employee list ordering for the "Include Inactive Employees" toggle
// (spec-inactive-toggle-sort-history.md). Active/notice-period employees
// (userState === 'Employee') sort first, preserving the existing lastName
// order among them; inactive employees sort after, by terminationDate
// descending. Mirrors the bias-then-tiebreak technique used for group
// ordering in SalaryCalculationTable.js (isFallbackGroup).

// A missing/null userState (e.g. a calc row with no matching HRMS user) is
// treated as "unknown", not "inactive" — sorted with active employees rather
// than silently pushed to the bottom, consistent with the backend endpoints.
const isKnownInactive = (employee) => employee?.userState != null && employee.userState !== 'Employee';

const rank = (employee) => (isKnownInactive(employee) ? 1 : 0);

/**
 * Comparator for Array.prototype.sort — active employees first (by
 * lastName), then inactive employees (by terminationDate desc, nulls last).
 * Never throws on a missing/falsy terminationDate.
 */
export const compareEmployeesForDisplay = (a, b) => {
  const r = rank(a) - rank(b);
  if (r !== 0) return r;
  if (rank(a) === 1) {
    // Both inactive: terminationDate desc, nulls last.
    if (!a?.terminationDate && !b?.terminationDate) return 0;
    if (!a?.terminationDate) return 1;
    if (!b?.terminationDate) return -1;
    return new Date(b.terminationDate) - new Date(a.terminationDate);
  }
  return (a?.lastName || '').localeCompare(b?.lastName || '');
};
